<template>
  <div class="sidebar">
    <h4 class="order">订单中心</h4>
    <ul>
      <li :class="{ act: act === 'orders' }">
        <router-link to="/center/orders">我的订单</router-link>
      </li>
      <li :class="{ act: act === 'favor' }">
        <router-link to="/center/favor">我的收藏</router-link>
      </li>
    </ul>
    <h4 class="setting">账户中心</h4>
    <ul>
      <li :class="{ act: act === 'info' }">
        <router-link to="/center/info">个人资料</router-link>
      </li>
      <li :class="{ act: act === 'safe' }">
        <router-link to="/center/safe">账户安全</router-link>
      </li>
      <li :class="{ act: act === 'points' }">
        <router-link to="/center/points">我的积分</router-link>
      </li>
      <li :class="{ act: act === 'address' }">
        <router-link to="/center/address">收货地址</router-link>
      </li>
    </ul>
    <h4 class="message">消息中心</h4>
    <ul>
      <li :class="{ act: act === 'reviews' }">
        <router-link to="/center/reviews">我的评价</router-link>
      </li>
      <li>站内信息</li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["act"],
  setup(props) {
    return { props };
  },
};
</script>

<style lang="less" scoped>
.sidebar {
  width: 200px;
  background: #ffffff;
  padding: 36px 0;

  h4 {
    position: relative;
    height: 40px;
    line-height: 40px;
    padding-left: 48px;
    font-size: 16px;
    color: #333c5b;
    font-weight: 700;

    &::before {
      content: "";
      position: absolute;
      display: block;
      top: 0;
      left: 20px;
      width: 16px;
      height: 40px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }
  }

  h4.order::before {
    background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNTk0IDIuMjVjLjE1NCAwIC4yODEuMTI3LjI4MS4yODFWMTUuNDdhLjI4Mi4yODIgMCAwIDEtLjI4MS4yODFIMS40MDZhLjI4Mi4yODIgMCAwIDEtLjI4MS0uMjgxVjIuNTNjMC0uMTU0LjEyNy0uMjgxLjI4MS0uMjgxem0tLjg0NCAxLjEyNUgyLjI1djExLjI1aDEzLjVWMy4zNzV6bS0yLjUzMSA2Ljc1Yy4xNTQgMCAuMjgxLjEyNy4yODEuMjgxdjEuNjg4YS4yODIuMjgyIDAgMCAxLS4yODEuMjgxSDQuNzhhLjI4Mi4yODIgMCAwIDEtLjI4MS0uMjgxdi0xLjY4OGMwLS4xNTQuMTI3LS4yODEuMjgxLS4yODF6bTAtMi44MTNjLjE1NCAwIC4yODEuMTI3LjI4MS4yODJ2LjU2MmEuMjgyLjI4MiAwIDAgMS0uMjgxLjI4MUg0Ljc4YS4yODIuMjgyIDAgMCAxLS4yODEtLjI4di0uNTYzYzAtLjE1NS4xMjctLjI4Mi4yODEtLjI4MnptMC0yLjI1Yy4xNTQgMCAuMjgxLjEyNy4yODEuMjgydi41NjJhLjI4Mi4yODIgMCAwIDEtLjI4MS4yODJINC43OGEuMjgyLjI4MiAwIDAgMS0uMjgxLS4yODJ2LS41NjJjMC0uMTU1LjEyNy0uMjgyLjI4MS0uMjgyeiIgZmlsbD0iIzMzM0M1QiIvPjwvc3ZnPg==");
  }

  h4.setting::before {
    background-image: url("data:image/svg+xml;base64,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");
  }

  h4.message::before {
    background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuNDc3IDguODM4YTMuNjQ0IDMuNjQ0IDAgMCAxIDMuNjQgMy42NGMwIC44LS4yNjIgMS41NDItLjcwMyAyLjE0NGwxLjUwNCAxLjUwNGEuMjguMjggMCAwIDEgMCAuMzk2bC0uMzk2LjM5NmEuMjguMjggMCAwIDEtLjM5NiAwbC0xLjUwNC0xLjUwNGEzLjYxNyAzLjYxNyAwIDAgMS0yLjE0NS43MDIgMy42NDQgMy42NDQgMCAwIDEtMy42NC0zLjYzOSAzLjY0NCAzLjY0NCAwIDAgMSAzLjY0LTMuNjM5ek0xNS4yNzcgMWEuMjguMjggMCAwIDEgLjI4LjI4djUuNTk4YS4yOC4yOCAwIDAgMS0uMjguMjhoLS41NmEuMjguMjggMCAwIDEtLjI4LS4yOFYyLjEySDIuMTJ2MTIuMzE3aDQuNzU5YS4yOC4yOCAwIDAgMSAuMjguMjh2LjU2YS4yOC4yOCAwIDAgMS0uMjguMjhoLTUuNmEuMjguMjggMCAwIDEtLjI3OS0uMjhWMS4yOEEuMjguMjggMCAwIDEgMS4yOCAxem0tMi44IDguOTU4Yy0xLjM4OSAwLTIuNTE5IDEuMTMtMi41MTkgMi41MiAwIDEuMzg4IDEuMTMgMi41MTggMi41MiAyLjUxOCAxLjM4OSAwIDIuNTE5LTEuMTMgMi41MTktMi41MTkgMC0xLjM5LTEuMTMtMi41Mi0yLjUyLTIuNTJ6bS01LjU5OCAxLjEyYS4yOC4yOCAwIDAgMSAuMjguMjh2LjU2YS4yOC4yOCAwIDAgMS0uMjguMjhoLTIuOGEuMjguMjggMCAwIDEtLjI4LS4yOHYtLjU2YS4yOC4yOCAwIDAgMSAuMjgtLjI4em0xLjEyLTMuMzZhLjI4LjI4IDAgMCAxIC4yOC4yOHYuNTZhLjI4LjI4IDAgMCAxLS4yOC4yOGgtMy45MmEuMjguMjggMCAwIDEtLjI4LS4yOHYtLjU2YS4yOC4yOCAwIDAgMSAuMjgtLjI4em0yLjIwNi0zLjM1OWMuMTcyIDAgLjMxMy4xNC4zMTMuMzEzdi40OTRjMCAuMTcyLS4xNC4zMTMtLjMxMy4zMTNINC4xMTJhLjMxNC4zMTQgMCAwIDEtLjMxMy0uMzEzdi0uNDk0YzAtLjE3Mi4xNDEtLjMxMy4zMTMtLjMxM3oiIGZpbGw9IiMzMzNDNUIiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==");
  }

  ul {
    padding-bottom: 15px;
    font-size: 14px;

    li {
      border-left: #fff solid 4px;
      padding: 0 16px 0 44px;
      height: 40px;
      line-height: 40px;

      a {
        color: #333c5b;
      }

      a:hover {
        color: #0273ff;
      }
    }

    .act {
      border-left: #0273ff solid 4px;
      background: #f4f8ff;

      a {
        color: #0273ff;
      }
    }
  }
}
</style>
